var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarineLantern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2078,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2583,
    y: 2418,
    width: 2078,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2583 -2418)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2583,
    y: 2418,
    width: 2078,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3624.09 2829.66C3972.09 2830.78 4253.3 3113.79 4252.18 3461.8 4251.07 3809.8 3968.05 4091.01 3620.05 4089.89 3272.05 4088.77 2990.84 3805.76 2991.95 3457.75 2993.07 3110.05 3275.62 2828.96 3623.33 2829.66L3622.93 3032.34C3386.86 3031.87 3195.11 3222.85 3194.64 3458.92 3194.16 3694.98 3385.15 3886.74 3621.21 3887.21 3857.28 3887.68 4049.03 3696.69 4049.5 3460.63 4049.98 3224.77 3859.3 3033.1 3623.44 3032.34Z",
    fill: "#FFEA01",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineLantern);
export default __webpack_public_path__ + "static/media/MarineLantern.6a1bbf9a875395791138eaebdccf30cd.svg";
export { ForwardRef as ReactComponent };